// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    ACCOUNT_PURGE_ACCOUNT_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    accountPurgeAccountResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* purgeAccount({ payload }) {
    try {
        let QUERY = `
            mutation purgeCompany ($id: Int!) {
                result: purgeCompany (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(accountPurgeAccountResult(data?.result))
        } else {
            yield put(accountPurgeAccountResult({ error: true }))
        }
        
    } catch (exc) {
        ExceptionManager(exc, 'Modules/accounts/views/components/purgeAccount/redux/saga', 'purgeAccount');
        yield put(accountPurgeAccountResult({ error: true }))
    }
}

function* watchMethods() {
    yield takeEvery(ACCOUNT_PURGE_ACCOUNT_REQUEST, purgeAccount);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}